import React, { FC, useState }                                             from "react";
import { useDispatch }                                                     from "react-redux";
import { Button, Icon, Modal, Pagination as PlanPagination, Radio, Table } from "semantic-ui-react";
import GetPlans
                                                                           from "../../../application/usecase/plan/GetPlans";
import GetPlansCount
                                                                           from "../../../application/usecase/plan/GetPlansCount";
import CurrentPage
                                                                           from "../../../domain/fundamentals/pagination/CurrentPage";
import Pagination
                                                                           from "../../../domain/fundamentals/pagination/Pagination";
import Plan                                                                from "../../../domain/plan/Plan";
import Plans                                                               from "../../../domain/plan/Plans";
import {
  initSelectedPlanAction,
  setSelectedPlanAction,
  useSelectedPlan
}                                                                          from "../../../infrastructure/redux/plan/selected";
import ListTotalCount                                                      from "../common/layout/ListTotalCount";
import TopSection                                                          from "../common/layout/TopSection";

const ReservationPlanSelector: FC = () => {
  const [open, setOpen] = useState(false);
  const [select, setSelect] = useState(new Plan());
  const [plans, setPlans] = useState(new Plans());
  const [pagination, setPagination] = useState(new Pagination());
  const [count, setCount] = useState(NaN);
  const dispatch = useDispatch();
  const getPlans: GetPlans = new GetPlans(dispatch);
  const getPlansCount: GetPlansCount = new GetPlansCount();
  const selectedPlan: Plan = useSelectedPlan();

  return (
    <>
      <Button
        icon
        labelPosition="left"
        onClick={ async () => {
          getPlans.execute(pagination).then(value => {
            setPlans(value.plans);
            setPagination(value.pagination);
          });
          getPlansCount.execute().then(value => setCount(value));
          setSelect(new Plan());
          setOpen(true);
        } }
      >
        <Icon name="ticket"/>
        {
          selectedPlan.id.isEmpty()
            ?
            "予約するプランを選択する"
            :
            selectedPlan.name.toString()
        }
      </Button>

      <Modal
        open={ open }
      >
        <Modal.Header>予約するプランの選択</Modal.Header>

        <Modal.Content>
          <>
            <TopSection>
              <Button
                onClick={ () => {
                  dispatch(initSelectedPlanAction());
                  setOpen(false);
                } }
              >
                選択済みのプランを解除する
              </Button>
            </TopSection>

            <ListTotalCount>{ count }件</ListTotalCount>
            <Table
              striped
              selectable
            >
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>選択</Table.HeaderCell>
                  <Table.HeaderCell>プラン名</Table.HeaderCell>
                  <Table.HeaderCell>金額</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {
                  plans.list.map(plan => (
                    <Table.Row onClick={ () => setSelect(plan) }>
                      <Table.Cell width={ 2 }>
                        <Radio
                          name="ReservationPlanSelector"
                          checked={ select.id.toNumber() === plan.id.toNumber() }
                          onChange={ () => setSelect(plan) }
                        />
                      </Table.Cell>
                      <Table.Cell>{ plan.name.toString() }</Table.Cell>
                      <Table.Cell>\{ plan.amount.toString() }</Table.Cell>
                    </Table.Row>
                  ))
                }
              </Table.Body>
            </Table>
            <PlanPagination
              totalPages={ pagination.current.value }
              activePage={ pagination.current.value }
              onPageChange={ (event, data) => {
                const newPagination = new Pagination(new CurrentPage(Number(data.activePage)), pagination.total);
                getPlans.execute(newPagination).then(value => setPlans(value.plans));
                getPlansCount.execute().then(value => setCount(value));
                setPagination(newPagination);
              } }
            />
          </>
        </Modal.Content>

        <Modal.Actions>
          <Button
            icon
            labelPosition="left"
            disabled={ select.id.isEmpty() }
            positive={ !select.id.isEmpty() }
            onClick={ () => {
              setOpen(false);
              dispatch(setSelectedPlanAction(select));
            } }
          >
            <Icon name="check"/>
            決定する
          </Button>

          <Button
            onClick={ () => setOpen(false) }
          >
            閉じる
          </Button>
        </Modal.Actions>
      </Modal>
    </>
  );
};

export default ReservationPlanSelector;
